import React from 'react'
import ReactDOM from 'react-dom'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom'

import './style.css'
import OverMarjan from './views/over-marjan'
import FotosAlbertGerrits from './views/fotos-albert-gerrits'
import FotosBijBoek from './views/fotos-bij-boek'
import AgendaEnMedia from './views/agenda-en-media'
import Home from './views/home'
import Contact from './views/contact'
import Prora from './views/prora'
import Gleiwitz from './views/gleiwitz'
import FotosAlbertWoltjes from './views/fotos-albert-woltjes'
import OverMijOud from './views/over-mij-oud'
import BlogLeegHorizontaleFoto from './views/blog-leeg-horizontale-foto'
import HeiligeWandelingen from './views/heilige-wandelingen'
import Vader from './views/vader'
import Woordkunst from './views/woordkunst'
import OnderzoekRAD from './views/onderzoek-rad'
import Moeder from './views/moeder'
import Roman from './views/roman'
import VIP from './views/vip'
import Vati from './views/vati'
import Proeverij from './views/proeverij'
import UBoot from './views/u-boot'
import WalkingInHisClogs from './views/walking-in-his-clogs'
import XINPUTDocumentenEnFotosTweeUitDuizenden from './views/x-input-documenten-en-fotos-twee-uit-duizenden'
import Blog from './views/blog'

const App = () => {
  return (
    <Router>
      <Switch>
        <Route component={OverMarjan} exact path="/over-marjan" />
        <Route
          component={FotosAlbertGerrits}
          exact
          path="/fotos-albert-gerrits"
        />
        <Route component={FotosBijBoek} exact path="/fotos-bij-boek" />
        <Route component={AgendaEnMedia} exact path="/agenda-en-media" />
        <Route component={Home} exact path="/" />
        <Route component={Contact} exact path="/contact" />
        <Route component={Prora} exact path="/prora" />
        <Route component={Gleiwitz} exact path="/gleiwitz" />
        <Route
          component={FotosAlbertWoltjes}
          exact
          path="/fotos-albert-woltjes"
        />
        <Route component={OverMijOud} exact path="/over-mij-oud" />
        <Route
          component={BlogLeegHorizontaleFoto}
          exact
          path="/blog-leeg-horizontale-foto"
        />
        <Route
          component={HeiligeWandelingen}
          exact
          path="/heilige-wandelingen"
        />
        <Route component={Vader} exact path="/vader" />
        <Route component={Woordkunst} exact path="/woordkunst" />
        <Route component={OnderzoekRAD} exact path="/onderzoek-rad" />
        <Route component={Moeder} exact path="/moeder" />
        <Route component={Roman} exact path="/roman" />
        <Route component={VIP} exact path="/vip" />
        <Route component={Vati} exact path="/vati" />
        <Route component={Proeverij} exact path="/proeverij" />
        <Route component={UBoot} exact path="/u-boot" />
        <Route
          component={WalkingInHisClogs}
          exact
          path="/walking-in-his-clogs"
        />
        <Route
          component={XINPUTDocumentenEnFotosTweeUitDuizenden}
          exact
          path="/x-input-documenten-en-fotos-twee-uit-duizenden"
        />
        <Route component={Blog} exact path="/blog" />
        <Redirect to="**" />
      </Switch>
    </Router>
  )
}

ReactDOM.render(<App />, document.getElementById('app'))
